var Mn = require('backbone.marionette');
require('jquery-mask-plugin');

module.exports = Mn.Behavior.extend({
    onAttach: function (view) {
        this.build(view.$el);
    },
    onChildviewAttach: function (view) {
        var content = view.$el;

        if (content.find('[data-mask-for]').length) {
            this.build(content);
        }
    },
    build: function (content) {
        $('[data-mask-for]', content).each(function(){
            if ($(this).data('mask-init'))
                return;

            $(this).data('mask-init', true);

            var mask = $(this).data('mask-for');

            switch(mask) {
                case 'cpf':
                    $(this).mask('000.000.000-00');
                break;
                case 'date':
                    $(this).mask('00/00/0000');
                break;
                case 'phone':
                    $(this).mask('(00) 00000-0000');
                break;
                case 'cep':
                    $(this).mask('00000-000');
                break;
                case 'code':
                    $(this).mask('AAA 000-A0A0');
                break;
            }
            
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/behaviors/Mask.js
// module id = 226
// module chunks = 3